import { makeRequest } from 'utils/requestLogger';

export default (roundtable) =>
  makeRequest('post', '/api/roundtables', roundtable);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/createRT.js